import { render, staticRenderFns } from "./FlexCenter.vue?vue&type=template&id=9a27e834&scoped=true"
import script from "./FlexCenter.vue?vue&type=script&lang=ts"
export * from "./FlexCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a27e834",
  null
  
)

export default component.exports